























import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import gsap from 'gsap'

@Component
export default class ActivationModal extends Vue {
    @Prop({ required: true, type: Boolean }) readonly trigger!: boolean
    @Prop({ default: 6, type: Number }) readonly minSteps!: number
    interval: NodeJS.Timeout = null
    visible: boolean = false
    step: number = 0
    progress: number = 0

    @Watch('trigger')
    async onTriggerChange(value: boolean): Promise<void> {
        if (!value) {
            return
        }

        this.visible = true
    }

    @Watch('visible')
    async onVisibleChange(value: boolean): Promise<void> {
        if (!value) {
            return
        }

        this.step = 0
        this.progress = 0
        this.interval = setInterval(async () => await this.nextStep(), 1000)
    }

    @Watch('step')
    async onStepChange(value: number): Promise<void> {

        // If trigger is false, show last message and hide.
        if (this.trigger === false && value >= this.minSteps) {
            this.step = this.activatingMessages.length - 1
            await this.wait()
        }

        // If we reached last step, hide modal.
        if (value >= this.activatingMessages.length - 1) {
            clearInterval(this.interval)
            await this.wait()
            await this.hide()
            return
        }

        // Tween progress.
        gsap.to(this, {
            progress: this.step,
            duration: .6,
            ease: 'power2.out',
        })
    }

    async nextStep(): Promise<void> {
        this.step++
        await this.wait()
    }

    async hide(): Promise<void> {
        this.visible = false
    }

    async wait(): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, 1000 * (Math.random() + 3000)))
    }

    get activatingMessages(): string[] {
        return [
            'Bezig met activeren van Smart Marketing..',
            'Verbinding maken met externe server..',
            'Beveiligde verbinding is opgezet..',
            'Bezig met AVG kaders opzetten..',
            'Lijsten aanmaken..',
            'Velden aanmaken..',
            'Terugkoppeling is ingesteld..',
            'Bezig met data overzetten..',
            'Externe terugkoppeling instellen..',
            'Nog even geduld..',
            'SmartMarketing is ingeschakeld!',
        ]
    }
}
